import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
} from '../common/ui/dialog';
import { toast } from 'sonner';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { deleteExtension } from '@/lib/action';


interface IDeleteConfirmationProps {
    open: boolean;
    onOpenChange: () => void;
    id: any
    updateTable: () => void;
    name: any,
    userid: any,
    sessionid: any
}

const RemoveExtensions = async (id: any, userid: any, sessionid: any): Promise<{ success: boolean; message: string }> => {
    try {
        let _res = await deleteExtension(id, userid, sessionid);
        if (_res?.data?.error || _res?.error) {
            return {
                success: false,
                message: _res?.data?.error ? _res?.data?.error : _res?.error,
            };
        } else {
            return {
                success: true,
                message: 'Extension deleted successfully!',
            };
        }
    } catch (error: any) {
        if (error.response?.status === 404) {
            return {
                success: false,
                message: `Extension with ID ${id} not found.`,
            };
        }

        return {
            success: false,
            message: error.response?.data?.message || 'Failed to delete extension.',
        };
    }
};

const DeleteConfirmation = ({ open, onOpenChange, id, updateTable, name, userid, sessionid }: IDeleteConfirmationProps) => {
    const intl = useIntl()
    const [buttonLoading, setButtonLoading] = useState<any>(false);
    const removeCategories = async (id: any) => {
        setButtonLoading(true);
        try {
            const result = await RemoveExtensions(id, userid, sessionid);

            if (result.success) {
                toast.success(result.message || intl.formatMessage({ id: 'EXTENSION_DELETED' }));
                updateTable();
            } else {
                toast.error(result.message || intl.formatMessage({ id: 'SOMETHING_WENT_WRONG' }));
            }

            onOpenChange();
        } catch (err) {
            toast.error(intl.formatMessage({ id: 'FAILED_REMOVE_EXTENSION' }));
        }
        setButtonLoading(false);
    }


    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="w-full max-w-[500px] max-h-[95%] scrollable-y-auto">
                <DialogHeader className="justify-end border-0 pt-5">
                    <DialogTitle></DialogTitle>
                    <DialogDescription></DialogDescription>
                </DialogHeader>
                <DialogBody className="flex flex-col items-center pt-0 pb-10">
                    <div className="mb-9">
                        <img
                            src={('/assets/media/illustrations/23.svg')}
                            className="dark:hidden max-h-[150px]"
                        />
                        <img
                            src={('/assets/media/illustrations/23-dark.svg')}
                            className="light:hidden max-h-[150px]"
                        />
                    </div>

                    <h3 className="text-lg font-medium text-gray-900 text-center mb-3">
                        <FormattedMessage id="DELETE_TITLE" />
                    </h3>

                    <div className="text-2sm text-center text-gray-700 mb-7">
                        <FormattedMessage id="DELETE_MESSAGE" values={{ name }} />
                    </div>

                    <div className='flex flex-wrap justify-center gap-2.5'>
                        <span onClick={() => onOpenChange()} className="btn btn-light flex justify-center">
                            <FormattedMessage id="DELETE_NO" />
                        </span>
                        <span onClick={() => removeCategories(id)} className="btn btn-primary flex justify-center">
                            {buttonLoading ? <FormattedMessage id="PLEASE_WAIT" /> : <FormattedMessage id="DELETE_YES" />}
                        </span>
                    </div>
                </DialogBody>
            </DialogContent>
        </Dialog>
    );
};

export { DeleteConfirmation };
